<template>
  <div class="how-to">
    <h1 class="text-shadow-thin-white">{{ $t("nurnberg.howToPlay") }}</h1>
    <p>{{ $t("nurnberg.howP1") }}</p>
    <p>
      {{ $t("nurnberg.howP2") }}
      <span class="highlight text-shadow-extra-thin-white">
        {{ $t("nurnberg.howP2Highlight") }}
      </span>
    </p>
    <p>{{ $t("nurnberg.howP3") }}</p>
  </div>
</template>
<script>
export default {
  name: "NurnbergHowTo",
};
</script>
